(function($){
  'use strict';

  function firstAvailableVariant(product){
    if(!product || !product.variants){ return null; }
    for(var i=0;i<product.variants.length;i++){
      if(product.variants[i].available){ return product.variants[i]; }
    }
    return null;
  }

  function syncQuickView(product){
    var $modal = $('#quickViewModal');
    if(!$modal.length){ return; }

    var variant = firstAvailableVariant(product);
    var $qty = $modal.find('input[name="quantity"]');
    if($qty.length){
      var q = parseInt($qty.val(),10);
      $qty.val((isNaN(q) || q < 1) ? 1 : q);
    }

    if(!variant){
      $modal.find('.addtocartqv').prop('disabled',true);
      return;
    }

    var $selectors = $modal.find('.single-option-selector');
    if($selectors.length && variant.options){
      $.each(variant.options,function(index,value){
        var $selector = $selectors.eq(index);
        if($selector.length && $selector.find('option[value="'+String(value).replace(/"/g,'\\"')+'"]').length){
          $selector.val(value).trigger('change');
        }
      });
    }

    var $master = $modal.find('#product-select-qv');
    if($master.length){
      $master.val(String(variant.id)).trigger('change');
    }

    $modal.find('.addtocartqv').prop('disabled',!variant.available);
  }

  if(window.Shopify && typeof Shopify.onProduct === 'function'){
    var originalOnProduct = Shopify.onProduct;
    Shopify.onProduct = function(product){
      originalOnProduct(product);
      setTimeout(function(){ syncQuickView(product); },50);
    };
  }

  $(document).on('shown.bs.modal','#quickViewModal',function(){
    var $qty = $(this).find('input[name="quantity"]');
    if($qty.length){
      var q = parseInt($qty.val(),10);
      $qty.val((isNaN(q) || q < 1) ? 1 : q);
    }
  });

  $(document).on('click','#quickViewModal .qtybutton',function(){
    var $qty = $(this).siblings('input[name="quantity"]');
    setTimeout(function(){
      var q = parseInt($qty.val(),10);
      if(isNaN(q) || q < 1){ $qty.val(1); }
    },0);
  });

  $(document).on('change blur','#quickViewModal input[name="quantity"]',function(){
    var q = parseInt($(this).val(),10);
    if(isNaN(q) || q < 1){ $(this).val(1); }
  });

})(jQuery);